export const CHANGE_STATE_ADD_MY_LIST_BUTTON =
  "CHANGE_STATE_ADD_MY_LIST_BUTTON";
export const CHANGE_STATE_ACTION_LIKE = "CHANGE_STATE_ACTION_LIKE";
export const SET_CHAPTERS = "SET_CHAPTERS";
export const SET_SERIES = "SET_SERIES";
export const SET_SEARCH_FOOTER = "content/SET_SEARCH_FOOTER";
export const SET_GRILL = "grill/SET_GRILL";
export const SET_JSONAPI = "jsonapi/SET_JSONAPI";
